module.exports = __webpack_public_path__ + "static/media/mycenaean_text_04.719a362e.png";